import { DateTime } from "luxon";
import { getCalendarUrl } from "../store/use-calendar-state-store";
import type { CalendarViewType } from "../types";

// Unified calendar URL generation using salon timezone
export function getCalendarUrlWithFragment(mode: CalendarViewType, date: DateTime): string {
  return getCalendarUrl(mode, date);
}
